import { getRoomInfo } from '../../global/blocs/roomInfo'
import { useSpeakersQuery } from '../../sharedLegacy/hooks/useSpeakersQuery'

const useIsLocalGuestSpeaker = () => {
  const { data: speakers } = useSpeakersQuery()
  const roomInfo = getRoomInfo()
  const isPresenter = roomInfo.role === 'presenter'

  return (
    isPresenter &&
    speakers?.find((speaker) => speaker.id === roomInfo.speakerId)
      ?.creationSource === 'guest'
  )
}

export { useIsLocalGuestSpeaker }
